import React, { useState } from "react";
import HoverToDisplayFullTitle from "../../reusableComponents/HoverToDisplayFullTitle";
import CustomChips from "../../reusableComponents/CustomChips";
import { useAuth } from "../../context/API_Client";
import { convertIsoToGivenDateFormat, sortDateTime } from "../utils/utils";
import { colorBrandObject } from "../../../constants/brandings";

export function ReconSchema(
  handleDonwnloadConflictFile,
  operationPermissions,
  operationStatuses
) {
  const { isAuthorizedPermission, timezone } = useAuth();
  const schema = {
    metadata: {
      title: "Reconciliation",
      minHeight: 600,
      minWidth: 500,
      position: "relative",
      rowHeight: 53,
      showTitle: false,
      defaultSortInfo: { name: "timestamp", dir: -1 },
    },
    fields: [
      {
        name: "fileId",
        header: "File ID",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 250,
        textAlign: "center",
        sortable: false,

        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {data?.fileId ? (
              <HoverToDisplayFullTitle title={data?.fileId} len={23} />
            ) : (
              <></>
            )}
          </div>
        ),
      },
      {
        name: "fileName",
        header: "File Name",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 250,
        textAlign: "center",
        sortable: false,
        textEllipsis: true,
        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {data?.metadata?.fileName ? (
              <HoverToDisplayFullTitle
                title={data?.metadata?.fileName}
                len={23}
              />
            ) : (
              <></>
            )}
          </div>
        ),
      },

      {
        name: "timestamp",
        header: "Created At",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 230,
        defaultFlex: 1,
        textAlign: "start",
        sortable: true,
        sort: sortDateTime,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{convertIsoToGivenDateFormat( data?.timestamp,timezone)}</span>
        ),
      },
      {
        name: "metadata.PAYOUT_TIMESTAMP",
        header: "Settlement Date",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 230,
        defaultFlex: 1,
        textAlign: "start",
        sortable: true,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>
            {data?.metadata?.settlementDate
              ? convertIsoToGivenDateFormat(
                  data?.metadata?.settlementDate,
                  timezone
                )
              : ""}
          </span>
        ),
      },
      {
        name: "processor",
        header: "Processor",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 140,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => (
          <span
            style={{
              display: "flex",
              marginLeft: "-20px",
              alignItems: "center",
            }}
          >
            {data?.pspInfo?.pspLogoUrl && (
              <img
                src={data?.pspInfo?.pspLogoUrl}
                style={{
                  height: "28px",
                  width: "28px",
                  objectFit: "contain",
                  marginRight: "8px",

                  mixBlendMode: "multiply",
                }}
              />
            )}
            {data?.pspInfo?.title}
          </span>
        ),
      },
      {
        name: "metadata.SETTLEMENT_CURRENCY",
        header: "Settlement Currency",
        visible: false,
        type: "string",
        filtering: false,
        minWidth: 230,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>
            {data?.metadata?.SETTLEMENT_CURRENCY}
          </span>
        ),
      },

      {
        name: "status",
        header: "Status",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 200,
        textAlign: "center",
        sortable: false,
        render: ({ data }) => (
          <div
            style={{
              marginLeft: "-12px",
              textTransform:"uppercase"
            }}
          >
            {data?.status && (
              <CustomChips
                text={
                  data?.status === "PROCESSED"
                    ? data?.reconciliationConflictCount > 0
                      ? data?.reconciliationConflictCount + " Conflicts"
                      : operationStatuses?.find(
                          (ele) => ele?.value === data?.status
                        )?.title
                    : operationStatuses?.find(
                        (ele) => ele?.value === data?.status
                      )?.title
                }
                type={
                  data?.status === "FAILED" ||
                  data?.reconciliationConflictCount > 0
                    ? 0
                    : data?.status === "IN_PROGRESS" ||
                      data?.status === "LOADED"
                    ? 2
                    : data?.reconciliationConflictCount > 0
                    ? 0
                    : 1
                }
              />
            )}
          </div>
        ),
      },
      {
        name: "actions",
        header: "Actions",
        visible: true,
        type: "string",
        filtering: false,
        defaultFlex: 1,
        minWidth: 150,
        textAlign: "center",
        alignItems: "center",
        sortable: false,
        render: ({ data }) => (
          <>
            {data?.status === "PROCESSED" &&
              data?.reconciliationConflictCount > 0 &&
              isAuthorizedPermission(
                operationPermissions?.downloadConflictFile
              ) && (
                <div
                  style={{
                    marginLeft: "-12px",
                    maxWidth: "180px",
                  }}
                >
                  <div style={{ display: "flex", gap: "8px" }}>
                    <img
                      src="/assets/downloadReport.svg"
                      style={{
                        height: "28px",
                        width: "28px",
                        objectFit: "contain",
                        marginRight: "8px",
                        mixBlendMode: "multiply",
                        marginLeft: "20px",
                        cursor: "pointer",
                        color:`${colorBrandObject?.actionIconColor}`                      }}
                      onClick={() => {
                        handleDonwnloadConflictFile(data?.fileId);
                      }}
                    />
                  </div>
                </div>
              )}
          </>
        ),
      },
    ],
  };
  return schema;
}
